<div class="card shadow-sm h-100 status-card clickable"
     [attr.data-status]="statusColor"
     (click)="handleClick()"
     [style.cursor]="clickable ? 'pointer' : 'default'">
  <div class="card-body d-flex flex-column">
    <div class="d-flex justify-content-between align-items-start mb-3">
      <div class="flex-grow-1">
        <h6 class="card-subtitle text-uppercase mb-2 fw-bold">
          {{ title | translateAsync }}
        </h6>
      </div>
      <div class="status-icon ms-2">
        <i [class]="'fa-solid ' + icon" style="font-size: 2rem; opacity: 0.3;"></i>
      </div>
    </div>

    <div class="mt-auto">
      <h2 class="display-4 fw-bold mb-0">
        {{ count }}
      </h2>
      <small class="text-muted" *ngIf="countLabel" translate>{{ countLabel }}</small>
    </div>

    <div class="mt-3 pt-2" *ngIf="clickable">
      <small class="text-muted d-flex align-items-center">
        <i class="fa-solid fa-arrow-right me-2"></i>
        <span translate>{{ footerText }}</span>
      </small>
    </div>
  </div>
</div>
